import axios, { CancelToken } from 'axios';
import { createAxiosConfig } from '../mockHelper';
import { GetNewBusinessCost } from '../contracts';
import { IGetNewBusinessCostRequest } from '@lib/types';
import LogCannon from '@ace-clublabs/log-cannon';

export const GetNewBusinessCostApi =
  (endpoint: string): GetNewBusinessCost =>
  async (request: IGetNewBusinessCostRequest, cancelToken?: CancelToken) => {
    try {
      const config = { ...createAxiosConfig(null, endpoint), cancelToken };
      const response = await axios.post(endpoint, request, config);
      LogCannon.blast('GetNewBusinessCostApi success');
      return Promise.resolve(response?.data);
    } catch (e) {
      return Promise.reject({ error: e });
    }
  };
